import * as z from "zod";

export const getHappyReturnsIntegration = {
  name: "getHappyReturnsIntegration" as const,
  input: z.object({}),
  output: z.object({
    happyReturnsIntegration: z
      .object({ enabled: z.boolean(), retailerId: z.string() })
      .optional(),
  }),
};

export const putHappyReturnsIntegration = {
  name: "putHappyReturnsIntegration" as const,
  input: z.object({
    enabled: z.boolean(),
    retailerId: z.string().trim().min(1, "Retailer ID is required"),
  }),
  output: z.object({}),
};
